import React from 'react';
import { connect } from 'react-redux';
import { config } from '../../../config/config';
import postAuthonticatedJSON from '../../../common/utils/functions/postAuthonticatedJSON';


class CaseCreate extends React.Component {
	componentDidMount() {
		const pro_uid = this.props.match.params.pro_uid;
		const tas_uid = this.props.match.params.tas_uid;

		const NewCaseData = {
			pro_uid: pro_uid,
			tas_uid: tas_uid,
		};

		let URL = config.apiServer + 'cases';
		postAuthonticatedJSON(URL, NewCaseData).then(res => {
			window.location.replace(
				'#/newInbox/detail/' + res.app_uid + '/1' + '&sid=' + localStorage.getItem('session_id')
			);
		});

		//http://esd.zn-mefa.ir:81/sysworkflow/fa/neoclassic/cases/open?APP_UID=9783020015b03d3931c20c3045398820&DEL_INDEX=3&action=todo
	}
	render() {
		return <div></div>;
	}
}

export default connect(state => state.newInbox)(CaseCreate);
